import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_false, assert_not_null, assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { ENUM__environment_type } from '@shared/enums/ENUM__environment_type';
import { FN_DTO_BASE__try_assert_standard_fields } from '@shared/network/_methods/FN_DTO_BASE__try_assert_standard_fields';
import { FN_DTO_BASE__try_assert_standard_fields_array } from '@shared/network/_methods/FN_DTO_BASE__try_assert_standard_fields_array';
import { service_socketio_client } from '../service_socketio_client';

export function add_socket_handler_client(event: string, handler: (data: any) => void) {
  let { events_map, socket } = service_socketio_client;

  assert_false(events_map.has(event), { event, assert_type: ENUM__error_type.VALIDATION_ITEM_ALREADY_EXISTS });
  events_map.add(event);

  assert_string_not_empty(event);
  assert_not_null(socket);

  let handler_wrapper = (data: any) => {
    if (CONSTANTS__environment_client.VITE_APP_ENVIRONMENT == ENUM__environment_type.LOCAL) {
      FN_DTO_BASE__try_assert_standard_fields_array(data);
      FN_DTO_BASE__try_assert_standard_fields(data);
    }

    handler(data);
  };

  socket.on(event, handler_wrapper);
}
